// Boards for people without an account (kept in this browser), and moving them into an account later.
import type { BoardBackground, SepiaElement } from "../../shared/model";
import { DEFAULT_BG } from "../../shared/model";
import { navigate } from "../app/router";
import { previewFor, templateByKey } from "../data/templates";
import { api } from "../sync/api";
import * as local from "../sync/localdb";

export async function createGuestBoard(title = "My first board", templateKey = "welcome", start?: { els: SepiaElement[]; bg: BoardBackground }): Promise<string> {
  const t = templateByKey(templateKey);
  const id = crypto.randomUUID().replace(/-/g, "").slice(0, 16);
  const els = start?.els ?? (t ? t.make() : []);
  const bg = start?.bg ?? t?.bg ?? DEFAULT_BG;
  await local.putGuestBoard({ id, title, bg, thumb: await previewFor(els, bg), createdAt: Date.now(), updatedAt: Date.now(), elCount: els.length });
  if (els.length) await local.writeEls("g:" + id, els, []);
  return id;
}

export async function startGuestBoard(): Promise<void> {
  const existing = await local.listGuestBoards();
  if (existing.length) {
    navigate("/g/" + existing[0].id);
    return;
  }
  navigate("/g/" + (await createGuestBoard()));
}

/** Upload this device's boards (and their images) into the signed-in account. */
export async function importGuestBoards(onProgress?: (done: number, total: number) => void): Promise<number> {
  const boards = await local.listGuestBoards();
  let done = 0;
  for (const b of boards) {
    const els = await local.loadEls("g:" + b.id);
    const fixed: SepiaElement[] = [];
    for (const el of els) {
      if (el.type === "image" && el.src.startsWith("local-")) {
        const blob = await local.getAssetBlob(el.src);
        if (!blob) continue;
        const up = await api.uploadAsset(blob);
        fixed.push({ ...el, src: up.id });
      } else fixed.push(el);
    }
    await api.createBoard({ title: b.title, bg: b.bg, els: fixed, thumb: b.thumb });
    await local.deleteGuestBoard(b.id);
    onProgress?.(++done, boards.length);
  }
  return done;
}
